import { render, staticRenderFns } from "./AssessmentTableActive.vue?vue&type=template&id=d0349e88&scoped=true"
import script from "./AssessmentTableActive.vue?vue&type=script&lang=js"
export * from "./AssessmentTableActive.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTableActive.vue?vue&type=style&index=0&id=d0349e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0349e88",
  null
  
)

export default component.exports